export const CategoryParent = {
	MATCH:       'match',
	COMPETITION: 'competition',
	TRAINING:    'training',
	OTHER:       'other',
	HIGHLIGHT:   'highlight',
};
